module.exports = __webpack_public_path__ + "img/shippingbanner.fd5e162c.png";